import React, { useEffect, useState } from "react";
import { connectLanguagePopUp } from "./languagePopUp.connect";
import { createPortal } from "react-dom";
import SVG_CloseIcon from "../../assets/images/svgs/close-dark.svg?react";
const modalRoot = document.querySelector("#modal-root");

const LanguagePopUp = ({
  open,
  onDidDismiss,
  language,
  actions,
  elementsParams,
}) => {
  const [selected, setSelected] = useState(language || "en");

  useEffect(() => {
    if (!onDidDismiss) {
      //  setTabButton(1)
      actions.setTab(1);
    }
  }, [onDidDismiss]);

  const onUpdate = () => {
    actions.setLangauage(selected);
    onDidDismiss(false);
  };

  return createPortal(
    <>
      {open && (
        <div
          id="popup-modal"
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh] items-center justify-center bg-bg_CasinoPopupBg"
           // Close modal on outside click
        >
          <div
            // className="z-2 popUpBoxShadow popUpOpenAnimation absolute bg-bg_loginPopupBg  rounded-md"
            className="fixed bottom-0 left-0 right-0 top-0 overflow-hidden flex h-[100dvh] w-dvw items-center justify-center bg-bg_color_popUpParentBg overflow-y-hidden z-[10000]"
            onClick={() => onDidDismiss(false)}
          >
            <div className="w-[100%] max-w-[500px] relative bg-bg_color_primary  font-lato relative bg-bg_loginPopupBg popUpOpenAnimation max-h-[80%] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
              <button
                className="absolute top-1 right-1 active:scale-95 transition-all duration-300"
                onClick={() => onDidDismiss(false)}
              >
                <svg
                  className="cursor-pointer z-50"
                  height="24"
                  width="24"
                  fill="var(--icon-color-secondary)"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fad"
                  data-icon="circle-xmark"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <g className="fa-duotone-group">
                    <path
                      fill="currentColor"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                    ></path>
                    <path
                      fill="white"
                      d="M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"
                    ></path>
                  </g>
                </svg>
              </button>
              <div className="px-4 pt-5 pb-4 bg-bg_color_primary sm:p-6 sm:pb-4 font-lato">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-text_color_primary1">
                      Select Language
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-text_color_primary1">
                        Choose your preferred language from the list below:
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "en"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("en")}
                      >
                        <span className="flex items-center justify-between">
                          English (EN)
                          {selected === "en" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "hi"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("hi")}
                      >
                        <span className="flex items-center justify-between">
                          हिंदी (HI)
                          {selected === "hi" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "mr"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("mr")}
                      >
                        <span className="flex items-center justify-between">
                          मराठी (MR)
                          {selected === "mr" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "gu"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("gu")}
                      >
                        <span className="flex items-center justify-between">
                          ગુજરાતી (GU)
                          {selected === "gu" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "kn"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("kn")}
                      >
                        <span className="flex items-center justify-between">
                          ಕನ್ನಡ (KN)
                          {selected === "kn" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "bn"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("bn")}
                      >
                        <span className="flex items-center justify-between">
                          বাংলা (BN)
                          {selected === "bn" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`relative overflow-hidden w-full px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:border-border_color_brand_primary text-text_color_primary1  ${
                          selected === "es"
                            ? "border-border_color_brand_primary bg-bg_color_secondary"
                            : "hover:bg-bg_color_secondary hover:border-border_color_brand_primary"
                        }`}
                        type="button"
                        onClick={() => setSelected("es")}
                      >
                        <span className="flex items-center justify-between">
                          Español (ES)
                          {selected === "es" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              fill="#ef8402"
                              viewBox="0 0 448 512"
                              className="w-5 h-5"
                            >
                              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                            </svg>
                          )}
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="px-4 py-3 bg-bg_color_primary sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="relative overflow-hidden inline-flex justify-center w-full px-4 py-2 text-base font-medium text-text_color_primary2 bg-bg_text_brand_primary border border-transparent rounded-md shadow-sm hover:bg-bg_text_brand_secondary focus:outline-none  sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => onUpdate()}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="relative overflow-hidden inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-text_color_primary1 bg-bg_color_secondary border border-border_color_primary rounded-md shadow-sm hover:bg-bg_color_secondary hover:border-[#ef8402] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-border_color_brand_primary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => onDidDismiss(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>,
    modalRoot
  );
};

export default connectLanguagePopUp()(LanguagePopUp);
